import { useInView } from "../hooks/useInView";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Header, Footer } from "../components/layout/SiteChrome";
import { request } from "../services/api";
import { imageUrl } from "../services/config";

const reviews = [
  { name: "Nitesh Arora", text: "I really had a great experience. The pickup person waited patiently to help reset my iPhone. Completely seamless process!", rating: 5, initials: "NA" },
  { name: "Rahul Verma", text: "Really a good platform to sell your old smartphone. I sold my old phone and got a great price. Highly recommended!", rating: 5, initials: "RV" },
  { name: "Aniket Tanwar", text: "Great communication skills. Best price I've received from any company. Thanks to the True Value Mobiles team.", rating: 5, initials: "AT" },
  { name: "Priya Sharma", text: "Got instant payment on the spot! No waiting, no haggling. The entire process took less than 10 minutes.", rating: 5, initials: "PS" },
  { name: "Arjun Kumar", text: "Brilliant and quick service! Sold my old phone in less than 24 hours. The technician was very professional.", rating: 5, initials: "AK" },
  { name: "Naman Rana", text: "Best deal for mobiles. Good service. I insist on visiting this site if you want to sell your phone. Excellent behavior!", rating: 5, initials: "NR" },
];

export default function HomePage() {
  const [q, setQ] = useState("");
  const [categories, setCategories] = useState<any[]>([]);
  const [allNodes, setAllNodes] = useState<any[]>([]);
  const [allProducts, setAllProducts] = useState<any[]>([]);
  const [showResults, setShowResults] = useState(false);
  const searchRef = useRef<HTMLDivElement>(null);
  const nav = useNavigate();

  useEffect(() => {
    request('/categories').then(data => setCategories(data.categories || [])).catch(console.error);
    request('/nodes').then(data => setAllNodes(data.nodes || [])).catch(console.error);
    request('/products').then(data => setAllProducts(data.products || [])).catch(console.error);
  }, []);

  const trimmed = q.trim().toLowerCase();
  let results: { label: string; sub: string; to: string; icon: string }[] = [];
  if (trimmed) {
    const seen = new Set<string>();
    const add = (r: { label: string; sub: string; to: string; icon: string }) => { if (seen.has(r.to)) return; seen.add(r.to); results.push(r); };
    allNodes.forEach(n => {
      if ((n.name || "").toLowerCase().includes(trimmed)) {
        if (!n.parentId) add({ label: n.name, sub: "Brand", to: `/brand/${n._id}`, icon: n.icon || "📦" });
        else { const pid = n.parentId?._id || n.parentId; if (pid) add({ label: n.name, sub: "Model", to: `/brand/${pid}`, icon: "📱" }); }
      }
    });
    categories.forEach(c => { if ((c.name || "").toLowerCase().includes(trimmed)) add({ label: c.name, sub: "Category", to: `/category/${c._id}`, icon: c.icon || "📂" }); });
    allProducts.forEach(p => { if ((p.name || "").toLowerCase().includes(trimmed)) { const nid = p.nodeId?._id || p.nodeId; if (nid) add({ label: p.name, sub: "Model", to: `/brand/${nid}`, icon: "📱" }); } });
    results = results.slice(0, 7);
  }

  const catRef    = useRef<HTMLElement>(null);
  const howRef    = useRef<HTMLElement>(null);
  const reviewRef = useRef<HTMLElement>(null);
  const sliderRef = useRef<HTMLDivElement>(null);

  const catVisible    = useInView(catRef);
  const howVisible    = useInView(howRef);
  const reviewVisible = useInView(reviewRef);

  const sortedCategories = [...categories].sort((a: any, b: any) => {
    const aHasProducts = allProducts.some((p: any) => {
      const pCatId = p.categoryId?._id || p.categoryId;
      return pCatId === a._id;
    });
    const bHasProducts = allProducts.some((p: any) => {
      const pCatId = p.categoryId?._id || p.categoryId;
      return pCatId === b._id;
    });
    if (aHasProducts && !bHasProducts) return -1;
    if (!aHasProducts && bHasProducts) return 1;
    return (a.sortOrder || 0) - (b.sortOrder || 0) || 0;
  });

  const mobileCat = categories.find((c: any) => (c.name || "").toLowerCase().includes("phone") || (c.name || "").toLowerCase().includes("mobile")) || categories[0];
  const sellTo = mobileCat ? `/category/${mobileCat._id}` : "/";

  const scrollSlider = (dir: number) => {
    if (!sliderRef.current) return;
    const w = sliderRef.current.offsetWidth * 0.7;
    sliderRef.current.scrollBy({ left: dir * w, behavior: "smooth" });
  };

  return (
    <div className="page-bg has-mobile-cta">
      <Header />

      {/* ── SEARCH BAR ── */}
      <section style={{ maxWidth: 600, margin: "0 auto", padding: "clamp(28px,5vw,44px) 20px clamp(12px,2vw,20px)" }}>
        <div ref={searchRef}
          onFocus={() => setShowResults(true)}
          onBlur={() => setTimeout(() => setShowResults(false), 150)}
          style={{ position: "relative", zIndex: 30 }}>
          <div className="hero-search-box" style={{ display: "flex", gap: 8, background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 14, padding: 6, boxShadow: "var(--shadow-lg)" }}>
            <input value={q} onChange={e => { setQ(e.target.value); setShowResults(true); }}
              onFocus={() => setShowResults(true)}
              onKeyDown={e => { if (e.key === "Enter") { setShowResults(false); if (results.length) nav(results[0].to); else nav(sellTo); } }}
              placeholder="Search — iPhone 15, Galaxy S24, OnePlus 12…"
              style={{ flex: 1, background: "transparent", border: "none", outline: "none", padding: "12px 16px", fontSize: 15, color: "var(--text)", fontFamily: "var(--font-body)", minWidth: 0 }} />
            <Link to={results.length ? results[0].to : sellTo} onClick={() => setShowResults(false)} style={{
              background: "linear-gradient(135deg, var(--brand), var(--brand-dark))",
              color: "#fff", borderRadius: 10, padding: "12px 24px", fontWeight: 700, fontSize: 14,
              whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: 5,
              boxShadow: "var(--shadow-glow)", flexShrink: 0, fontFamily: "var(--font-display)",
            }}>
              Get My Price
            </Link>
          </div>

          {showResults && trimmed && (
            <div onMouseDown={e => e.preventDefault()} style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 14, boxShadow: "var(--shadow-xl)", zIndex: 50, overflow: "hidden" }}>
              {results.length === 0 ? (
                <div style={{ padding: "16px 18px", fontSize: 13, color: "var(--text2)" }}>No matches for "{q}"</div>
              ) : results.map((r, i) => (
                <Link key={r.to + i} to={r.to} onClick={() => setShowResults(false)} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 16px", textDecoration: "none", borderTop: i > 0 ? "1px solid var(--border)" : "none", transition: "background 0.15s" }}
                  onMouseEnter={e => (e.currentTarget.style.background = "var(--surface2)")}
                  onMouseLeave={e => (e.currentTarget.style.background = "transparent")}>
                  <span style={{ width: 32, height: 32, borderRadius: 9, background: "var(--indigo-light)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>{r.icon}</span>
                  <span style={{ flex: 1, minWidth: 0 }}>
                    <span style={{ display: "block", fontSize: 14, fontWeight: 600, color: "var(--text)" }}>{r.label}</span>
                    <span style={{ display: "block", fontSize: 11, color: "var(--text3)" }}>{r.sub}</span>
                  </span>
                  <span style={{ fontSize: 13, color: "var(--text3)" }}>›</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ── HERO ── */}
      <section className="hero-backdrop" style={{ padding: "clamp(32px,7vw,56px) 20px clamp(28px,6vw,48px)" }}>
        <div style={{ maxWidth: 900, margin: "0 auto", textAlign: "center" }}>
          <p className="animate-fade-up" style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--brand)", marginBottom: 10 }}>
            BEST PRICE GUARANTEED
          </p>
          <h1 className="animate-fade-up delay-1" style={{
            fontFamily: "var(--font-display)", fontSize: "clamp(28px,5vw,44px)", fontWeight: 800,
            lineHeight: 1.15, letterSpacing: "-0.8px", color: "var(--text)", marginBottom: 12,
          }}>
            What are you looking to do?
          </h1>
          <p className="animate-fade-up delay-2" style={{ fontSize: 15, color: "var(--text2)", lineHeight: 1.7, marginBottom: 32, maxWidth: 520, margin: "0 auto 32px" }}>
            Sell your device at the best price or learn how our simple process works.
          </p>

          {/* Action cards */}
          <div className="hero-actions animate-fade-up delay-3" style={{ margin: "0 auto 36px" }}>
            <Link to="/sell" className="hero-action-card hero-action-card--sell">
              <div className="hero-action-card__icon">📱</div>
              <div className="hero-action-card__title">Sell Device</div>
              <div className="hero-action-card__desc">Sell your device with us at the best price</div>
            </Link>
            <Link to="/how-it-works" className="hero-action-card hero-action-card--info">
              <div className="hero-action-card__icon">🔍</div>
              <div className="hero-action-card__title">How It Works</div>
              <div className="hero-action-card__desc">Learn about our simple 3-step process</div>
            </Link>
          </div>

          {/* Trust chips */}
          <div className="animate-fade-up delay-5" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, flexWrap: "wrap", marginTop: 4 }}>
            {["⭐ 4.9/5 rated", "2M+ happy sellers", "Instant Payment", "Free Pickup"].map(t => (
              <span key={t} style={{ fontSize: 12, color: "var(--text2)", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 99, padding: "5px 14px", fontWeight: 600, boxShadow: "var(--shadow-sm)", whiteSpace: "nowrap" }}>{t}</span>
            ))}
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section id="how" ref={howRef} style={{ padding: "clamp(40px,7vw,64px) 20px", background: "var(--surface)", borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "clamp(28px,5vw,44px)" }} className={howVisible ? "animate-fade-up" : ""}>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--brand)", marginBottom: 8 }}>SIMPLE PROCESS</p>
            <h2 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(24px,4vw,36px)", fontWeight: 800, color: "var(--text)", letterSpacing: "-0.5px" }}>How It Works</h2>
          </div>
          <div className="steps-grid">
            {[
              { n: "1", title: "Get Your Device Valuation", desc: "Select your brand and model, answer a few quick questions about your phone's condition, and get the best price instantly." },
              { n: "2", title: "Schedule Pickup", desc: "If satisfied with the price, choose a convenient time slot and payment mode. Our agent will visit at your chosen time." },
              { n: "3", title: "Get Paid", desc: "Get paid in cash or online transfer. We accept cash, credit card, debit card, and bank transfer — all on the spot." },
            ].map((s, i) => (
              <div key={s.n} className={`step-card ${howVisible ? `animate-fade-up delay-${i + 1}` : ""}`}>
                <div className="step-card__number">{s.n}</div>
                <div className="step-card__title">{s.title}</div>
                <div className="step-card__desc">{s.desc}</div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 36 }}>
            <Link to={sellTo} style={{
              display: "inline-block", background: "linear-gradient(135deg, var(--brand), var(--brand-dark))",
              color: "#fff", fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 15,
              borderRadius: 12, padding: "14px 36px", boxShadow: "0 8px 24px rgba(255,107,53,0.3)",
              textDecoration: "none", transition: "all 0.2s",
            }}
              onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.transform = "translateY(-2px)"; el.style.boxShadow = "0 12px 32px rgba(255,107,53,0.4)"; }}
              onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.transform = ""; el.style.boxShadow = "0 8px 24px rgba(255,107,53,0.3)"; }}>
              Start Selling Now →
            </Link>
          </div>
        </div>
      </section>

      {/* ── CATEGORIES ── */}
      <section ref={catRef} style={{ background: "var(--surface)", padding: "clamp(40px,7vw,64px) 20px", borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)" }}>
        <div style={{ maxWidth: 1160, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "clamp(24px,5vw,40px)" }} className={catVisible ? "animate-fade-up" : ""}>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--brand)", marginBottom: 8 }}>CATEGORIES</p>
            <h2 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(24px,4vw,36px)", fontWeight: 800, color: "var(--text)", letterSpacing: "-0.5px" }}>What are you looking to sell?</h2>
            <p style={{ fontSize: 14, color: "var(--text2)", marginTop: 8 }}>Best price guaranteed — it takes just 1 minute to get your quote.</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 12 }}>
            {sortedCategories.map((c, i) => <CategoryCard key={c.id} c={c} delay={i * 90} visible={catVisible} />)}
          </div>
        </div>
      </section>

      {/* ── REVIEWS ── */}
      <section ref={reviewRef} style={{ maxWidth: 1160, margin: "0 auto", padding: "clamp(40px,7vw,64px) 20px" }}>
        <div style={{ textAlign: "center", marginBottom: "clamp(24px,5vw,40px)" }} className={reviewVisible ? "animate-fade-up" : ""}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--brand)", marginBottom: 8 }}>OUR CUSTOMERS</p>
          <h2 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(24px,4vw,36px)", fontWeight: 800, color: "var(--text)", letterSpacing: "-0.5px", marginBottom: 16 }}>What Our Customers Say</h2>

          {/* Rating summary */}
          <div className="reviews-summary">
            <span className="reviews-score">4.3</span>
            <div>
              <div className="reviews-stars">★★★★<span style={{ opacity: 0.35 }}>★</span></div>
              <div className="reviews-label">Based on Customer Reviews</div>
            </div>
          </div>
        </div>

        <div style={{ position: "relative" }}>
          {/* Nav arrows */}
          <button onClick={() => scrollSlider(-1)} style={{
            position: "absolute", left: -4, top: "50%", transform: "translateY(-50%)", zIndex: 10,
            width: 40, height: 40, borderRadius: "50%", border: "1.5px solid var(--border)",
            background: "var(--surface)", boxShadow: "var(--shadow-md)", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, color: "var(--text)",
            transition: "all 0.2s",
          }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--brand)"; e.currentTarget.style.color = "var(--brand)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.color = "var(--text)"; }}>
            ‹
          </button>
          <button onClick={() => scrollSlider(1)} style={{
            position: "absolute", right: -4, top: "50%", transform: "translateY(-50%)", zIndex: 10,
            width: 40, height: 40, borderRadius: "50%", border: "1.5px solid var(--border)",
            background: "var(--surface)", boxShadow: "var(--shadow-md)", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, color: "var(--text)",
            transition: "all 0.2s",
          }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--brand)"; e.currentTarget.style.color = "var(--brand)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.color = "var(--text)"; }}>
            ›
          </button>

          <div ref={sliderRef} className="reviews-slider" style={{
            display: "flex", overflowX: "auto", scrollSnapType: "x mandatory",
            gap: 16, paddingBottom: 4, scrollBehavior: "smooth",
            msOverflowStyle: "none", scrollbarWidth: "none",
          }}>
            {reviews.map((r, i) => (
              <div key={i}
                className={reviewVisible ? `animate-fade-up delay-${Math.min(i + 1, 6)}` : ""}
                style={{
                  scrollSnapAlign: "start", flex: "0 0 min(320px, 80vw)",
                  background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 16,
                  padding: "24px 22px", display: "flex", flexDirection: "column", gap: 14,
                  transition: "border-color 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--brand)"; e.currentTarget.style.boxShadow = "var(--shadow-lg)"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.boxShadow = "none"; }}>
                <div style={{ color: "#f59e0b", fontSize: 15, letterSpacing: 1 }}>{"★★★★★"}</div>
                <p style={{ fontSize: 14, color: "var(--text)", lineHeight: 1.7, flex: 1 }}>"{r.text}"</p>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 4 }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: 10, background: "var(--brand-light)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 13, fontWeight: 700, color: "var(--brand)", flexShrink: 0,
                  }}>{r.initials}</div>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text)", fontFamily: "var(--font-display)" }}>{r.name}</div>
                    <div style={{ fontSize: 11, color: "var(--text3)" }}>★ Verified Customer</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA BANNER ── */}
      <section style={{ maxWidth: 1160, margin: "0 auto 48px", padding: "0 20px" }}>
        <div style={{
          background: "linear-gradient(135deg, #ff6b35 0%, #e85a25 50%, #d94a1a 100%)",
          borderRadius: 24, padding: "clamp(36px,6vw,56px) clamp(24px,5vw,48px)",
          textAlign: "center", position: "relative", overflow: "hidden",
        }}>
          <div style={{ position: "absolute", top: -60, right: -60, width: 220, height: 220, borderRadius: "50%", background: "rgba(255,255,255,0.08)", pointerEvents: "none" }} />
          <div style={{ position: "absolute", bottom: -50, left: -50, width: 180, height: 180, borderRadius: "50%", background: "rgba(255,255,255,0.05)", pointerEvents: "none" }} />
          <h2 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(22px,4vw,34px)", fontWeight: 800, color: "#fff", letterSpacing: "-0.5px", marginBottom: 12, position: "relative" }}>
            Ready to Get Instant Cash?
          </h2>
          <p style={{ fontSize: "clamp(14px,2vw,16px)", color: "rgba(255,255,255,0.85)", marginBottom: 28, position: "relative", maxWidth: 480, margin: "0 auto 28px" }}>
            Join 2 million+ sellers who've experienced the easiest way to sell their devices.
          </p>
          <Link to="/sell" style={{
            display: "inline-block", background: "#fff", color: "var(--brand-dark)",
            borderRadius: 12, padding: "14px 36px", fontWeight: 700, fontSize: 15,
            fontFamily: "var(--font-display)", boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
            transition: "all 0.2s", position: "relative",
          }}
            onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.transform = "translateY(-2px)"; el.style.boxShadow = "0 12px 32px rgba(0,0,0,0.2)"; }}
            onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.transform = ""; el.style.boxShadow = "0 8px 24px rgba(0,0,0,0.15)"; }}>
            Sell My Device →
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}

type Category = { _id: string; name: string; icon: string; description: string; image?: { url: string } };

function CategoryCard({ c, delay, visible }: { c: Category; delay: number; visible: boolean }) {
  const [hov, setHov] = useState(false);
  return (
    <Link to={`/category/${c._id}`}
      className={visible ? "animate-fade-up" : ""}
      style={{ animationDelay: `${delay}ms`, display: "block", textDecoration: "none" }}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      <div style={{
        background: "var(--surface)",
        border: hov ? "1.5px solid var(--brand)" : "1.5px solid var(--border)",
        borderRadius: 14, padding: "18px 14px 16px", textAlign: "center",
        transition: "all 0.25s cubic-bezier(0.4,0,0.2,1)",
        transform: hov ? "translateY(-4px)" : "none",
        boxShadow: hov ? "0 8px 24px rgba(255,107,53,0.12)" : "var(--shadow-sm)",
        cursor: "pointer", height: "100%",
      }}>
        <div style={{ height: 56, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 10 }}>
          {c.image?.url ? (
            <img src={imageUrl(c.image.url)} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
          ) : (
            <span style={{ fontSize: 40 }}>{c.icon}</span>
          )}
        </div>
        <h3 style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, color: "var(--text)" }}>{c.name}</h3>
      </div>
    </Link>
  );
}
